import React, { useEffect, useState, useRef } from 'react';
import Slider from 'react-slick';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import CourseDetailsModal from './CourseDetailsModal';
import config from '../config/config.json';
import { useNavigate } from 'react-router-dom';

const CourseCard = ({ course, onHover, onLeave, api_url }) => {
    const navigate = useNavigate();

    const handleAddToCart = (course) => {
        const user = JSON.parse(localStorage.getItem('user'));
        if (!user) return navigate('/login-users-pf-ds-bd');

        const storedCart = localStorage.getItem('cart');
        const cart = storedCart ? JSON.parse(storedCart) : [];

        const existingItemIndex = cart.findIndex(item => item.id === course.courseId);

        if (existingItemIndex !== -1) {
            cart[existingItemIndex].quantity += 1;
        } else {
            cart.push({
                id: course.courseId,
                name: course.courseName,
                price: course.pricing || 0,
                quantity: 1,
                image: course.courseThumbnail || '',
                courseTag: course.courseTag || '',
                courseType: course.courseType || '',
                noOfEnrollments: course.noOfEnrollments || 0,
                batchStartDate: course.batchStartDate || null,
                batchEndDate: course.batchEndDate || null,
                userid: course.userid || null,
                courseThumbnail: course.courseThumbnail || '',
                categoryType: course.categoryType || '',
                skillCategoryType: course.skillCategoryType || '',
                rating: course.rating || 0,
                totalRating: course.totalRating || 0,
                courseDescription: course.courseDescription || ''
            });
        }

        localStorage.setItem('cart', JSON.stringify(cart));
    };

    return (
        <section
            className="relative max-w-sm w-full h-full bg-white border rounded-lg overflow-hidden shadow-md transition-transform transform hover:scale-105 hover:shadow-lg"
            onMouseEnter={onHover}
            onMouseLeave={onLeave}
        >
            <img className="w-full h-40 object-cover" src={`${api_url}/${course.courseThumbnail || 'placeholder.png'}`} alt={course.courseName} />
            <div className="p-4 flex flex-col justify-between h-full">
                <h5 className="mb-2 text-2xl font-bold text-gray-900">{course.courseName}</h5>
                <p className="font-normal tracking-[0.5px] text-white line-clamp-3 mb-2 w-fit text-xs py-1 px-2 bg-orange-500">{course.courseTag}</p>
                <p className="font-semibold text-gray-700 line-clamp-3 mb-2">{course.userName}</p>

                <div className='flex space-x-2 items-center mb-2'>
                    <p className="font-bold text-gray-700">{course.totalRating || 0}</p>
                    <div className="flex items-center">
                        {Array.from({ length: 5 }, (_, index) => (
                            <svg key={index} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="size-4 text-yellow-500">
                                {index < (course.totalRating || 0) ? (
                                    <path fillRule="evenodd" d="M10.788 3.21c.448-1.077 1.976-1.077 2.424 0l2.082 5.006 5.404.434c1.164.093 1.636 1.545.749 2.305l-4.117 3.527 1.257 5.273c.271 1.136-.964 2.033-1.96 1.425L12 18.354 7.373 21.18c-.996.608-2.231-.29-1.96-1.425l1.257-5.273-4.117-3.527c-.887-.76-.415-2.212.749-2.305l5.404-.434 2.082-5.005Z" clipRule="evenodd"/>
                                ) : (
                                    <path fillRule="evenodd" d="M12 2c.674 0 1.316.337 1.682.909l2.083 5.006 5.404.434c1.164.093 1.636 1.545.749 2.305l-4.117 3.527 1.257 5.273c.271 1.136-.964 2.033-1.96 1.425L12 18.354 7.373 21.18c-.996.608-2.231-.29-1.96-1.425l1.257-5.273-4.117-3.527c-.887-.76-.415-2.212.749-2.305l5.404-.434 2.082-5.005c.366-.572 1.008-.909 1.682-.909Zm0 2.23l-1.733 4.166c-.183.441-.609.742-1.098.78l-4.393.353 3.323 2.847c.354.303.514.785.402 1.24l-1.014 4.249 3.573-2.181c.414-.253.938-.253 1.352 0l3.573 2.181-1.014-4.249c-.112-.455.048-.937.402-1.24l3.323-2.847-4.393-.353c-.49-.038-.915-.339-1.098-.78L12 4.23Z" clipRule="evenodd"/>
                                )}
                            </svg>
                        ))}
                    </div>
                    <p className="font-medium text-gray-700 text-xs">({course.noOfEnrollments || 0})</p>
                </div>
                <p className="font-bold text-gray-800 mb-2">₹{course.pricing || 0}</p>

                <button onClick={() => handleAddToCart(course)} className="inline-flex items-center px-3 py-2 text-sm font-medium text-center text-white bg-blue-700 rounded-lg hover:bg-blue-800">
                    Add to Cart
                </button>
            </div>
        </section>
    );
};

const CourseCarousel = () => {
    const slider = useRef(null);
    const [courses, setCourses] = useState([]);
    const [hoveredCourse, setHoveredCourse] = useState(null);
    const [modalPosition, setModalPosition] = useState({});
    const { API_BASE_URL } = config;

useEffect(() => {
    const fetchCourses = async () => {
        try {
            const user = JSON.parse(localStorage.getItem("user"));
             const schoolId = localStorage.getItem("schoolId");
            const response = await fetch(
                `${API_BASE_URL}/Courses/GetAllCourses/-1?isBook=false`,
                {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json",
                        "UserID": user?.uuid, // ✅ USE UUID HERE
                        "Authorization": `Bearer ${user?.token}`,
                        "SchoolID": schoolId 
                    }
                }
            );

            if (response.ok) {
                const data = await response.json();
                setCourses(data);
            } else {
                console.error("Error fetching courses");
            }
        } catch (err) {
            console.error("Error fetching courses:", err);
        }
    };

    fetchCourses();
}, [API_BASE_URL]);
    const handleMouseEnter = (course, event) => {
        const rect = event.currentTarget.getBoundingClientRect();
        const modalWidth = 320;
        let left = rect.right + 10;
        if (left + modalWidth > window.innerWidth) left = rect.left - modalWidth - 10;

        setModalPosition({ top: rect.top + window.scrollY, left });
        setHoveredCourse(course);
    };

    const handleMouseLeave = () => setHoveredCourse(null);

    const settings = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [
            { breakpoint: 1024, settings: { slidesToShow: 2 } },
            { breakpoint: 768, settings: { slidesToShow: 1 } },
            { breakpoint: 480, settings: { slidesToShow: 1 } }
        ],
    };

    return (
        <section className='min-h-screen p-1 bg-gray-100 pb-4'>
            <div className="max-w-xl mt-6 mb-10 md:mx-auto sm:text-center lg:max-w-2xl md:mb-12 p-1">
                <h2 className="max-w-lg mb-6 font-sans text-3xl font-bold leading-none tracking-tight text-gray-700 sm:text-4xl md:mx-auto">
                    Transform Your Career Path with Edumitram
                </h2>
                <p className="text-gray-700 md:text-md text-sm">
                    Unlock access to an extensive library of courses, Specializations, and Professional Courses taught by top educators.
                </p>
            </div>
            <div className="mx-auto max-w-7xl">
                <Slider ref={slider} {...settings}>
                    {courses.map((course, i) => (
                        <div key={i} className="p-2">
                            <CourseCard
                                course={course}
                                onHover={(e) => handleMouseEnter(course, e)}
                                onLeave={handleMouseLeave}
                                api_url={API_BASE_URL}
                            />
                        </div>
                    ))}
                </Slider>
            </div>
            <div className='max-w-7xl pt-1 space-x-3 mx-auto flex justify-center md:justify-start'>
                <button onClick={() => slider.current.slickPrev()} className='w-14 h-14 text-gray-700 shadow-md border rounded-full flex items-center justify-center hover:bg-gray-200/70'>
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="3" stroke="currentColor" className="h-6 w-6">
                        <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 19.5 8.25 12l7.5-7.5" />
                    </svg>
                </button>
                <button onClick={() => slider.current.slickNext()} className='w-14 h-14 text-gray-700 shadow-md border rounded-full flex items-center justify-center hover:bg-gray-200/70'>
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="3" stroke="currentColor" className="h-6 w-6">
                        <path strokeLinecap="round" strokeLinejoin="round" d="m8.25 4.5 7.5 7.5-7.5 7.5" />
                    </svg>
                </button>
            </div>
            {hoveredCourse && <CourseDetailsModal course={hoveredCourse} position={modalPosition} />}
        </section>
    );
};

export default CourseCarousel;
